import React, { Component } from 'react';
import FontIcon             from 'material-ui/FontIcon';
import { browserHistory }   from 'react-router';
import { secondaryIcon }    from './../css/Styles';
import './../css/App.css';

class GoBackIcon extends Component
{
    onReturn = () =>
    {
        browserHistory.goBack();
    };

    render = () => {
        return (
            <FontIcon
                onTouchTap={this.onReturn}
                color={ secondaryIcon.color }
                style={ { ...secondaryIcon.style, float: 'left' } }
                className="material-icons tap-event">arrow_back</FontIcon>
        );
    };

}

export default GoBackIcon;



// WEBPACK FOOTER //
// ./src/components/GoBackIcon.js